module.exports = __webpack_public_path__ + "img/contact-method-5.b6fd251a.png";